// PanelControlPage.js más compacto (iconos y cards 15% más pequeños)
import React from 'react';
import { UserCog, KeyRound, Settings, Database, BarChart2, ShieldCheck, Users,FileStack} from 'lucide-react';

const panelOptions = {
  cuentas: {
    label: 'Cuentas',
    icon: <Users className="h-4 w-4 md:h-5 md:w-5 text-[#003865]" />,
    desc: 'Empresas, clientes y aliados',
    onClick: () => alert('cuentas')
  },
  usuarios: {
    label: 'Usuarios',
    icon: <UserCog className="h-4 w-4 md:h-5 md:w-5 text-blue-600" />,
    desc: 'Crear y asignar roles',
    onClick: () => alert('Ir a usuarios') 
  },
  
  planes: {
  label: 'Planes',
  icon: <FileStack className="h-4 w-4 md:h-5 md:w-5 text-orange-500" />,
  desc: 'Actualiza Planes Documentos',
  onClick: () => alert('Ir a usuarios')
  },
  Roles: {
    label: 'Roles Usuario',
    icon: <KeyRound className="h-4 w-4 md:h-5 md:w-5 text-green-600" />,
    desc: 'Gestión de accesos',
    onClick: () => alert('Ir a permisos')
  },
  
  monitoreo: {
    label: 'Monitoreo',
    icon: <BarChart2 className="h-4 w-4 md:h-5 md:w-5 text-fuchsia-600" />,
    desc: 'Eventos y logs',
    onClick: () => alert('Ir a monitoreo')
  },
  Documentos: {
    label: 'Informes Documentos',
    icon: <BarChart2 className="h-4 w-4 md:h-5 md:w-5 text-fuchsia-600" />,
    desc: 'Documentos X Cuenta',
    onClick: () => alert('Ir a monitoreo')
  },

};

export default function PanelControlPage({ setActivePage }) {
  return (
    <div className="p-2 max-h-screen overflow-y-auto">
      <h2 className="text-xl font-bold mb-3">Panel de Control</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 gap-2">
        {Object.entries(panelOptions).map(([key, item]) => (
          <div
            key={key}
            className="bg-white rounded-lg shadow p-2 flex flex-col items-center gap-1 cursor-pointer border border-gray-100 transition-all duration-150
              hover:bg-[#e3f2fd] hover:shadow-md hover:scale-105 hover:border-[#003865] min-w-[85px] min-h-[75px]"
            onClick={() => item.onClick(setActivePage)}
          >
            <div className="mb-1">{item.icon}</div>
            <div className="text-[13px] font-medium text-gray-800 text-center">{item.label}</div>
            <div className="text-gray-500 text-[11px] text-center leading-tight line-clamp-2">{item.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
